module.exports = __webpack_public_path__ + "img/gebratenerreismithintergrund.12ad9f08.jpg";